import { types, Instance } from 'mobx-state-tree';
const { model, identifierNumber, string, maybeNull } = types;

export const UserProfileInfoModel = model('UserProfileInfoModel', {
  id: identifierNumber,
  organizationName: maybeNull(string),
  fullName: string,
  email: string,
  password: string,
  confirm_password: string,
  title: maybeNull(string),
  department: maybeNull(string),
  phone: maybeNull(string),
  address: maybeNull(string),
  billingContactInformationFullName: string,
  billingContactInformationTitle: maybeNull(string),
  billingContactInformationDepartment: maybeNull(string),
  billingContactInformationEmail: string,
  billingContactInformationPhone: maybeNull(string),
  lastLogin: maybeNull(string),
  salesTaxGstVatExemptOrganization: maybeNull(string),
});

export type IUserProfileInfoModel = Instance<typeof UserProfileInfoModel>;
